// extracted by mini-css-extract-plugin
export default {"titulo":"Titulo_titulo__4HpJq"};